import { getPartnerOnClientSide } from "@tm/insurance/utils";
import { PARTNER } from "@tm/isomorphic-utils";
import InsuranceListing from "./InsuranceListing/InsuranceListing";
import InsuranceListingV2 from "./InsuranceListingV2/InsuranceListingV2";
import { ListingPageProps, ListingPageV2Props } from "./types";

const InsuranceListingWrapper = (
  props: ListingPageProps | ListingPageV2Props
) => {
  const partner = getPartnerOnClientSide();

  return (
    <>
      {partner === PARTNER.MYPARTNER ? (
        <InsuranceListingV2 {...(props as ListingPageV2Props)} />
      ) : (
        <InsuranceListing
          listingData={(props as ListingPageProps).listingData}
        />
      )}
    </>
  );
};

export default InsuranceListingWrapper;
